import { gql } from "generated-graphql";

export const GET_STEERS_CREDENTIALS_PAGE_DATA = gql(`
  query SteersCredentialsPageData($cn: String) {
    steersCredentialsPageData(cn: $cn) {
      credentials {
        id
        username
        name
        cnCount
        tenantId
      }
      mappings {
        alternateIdInfo {
          id
          alternateIdType
          alternateIdValue
          tenantId
          tenant {
            id
            name
          }
          description
        }
        credentialCount
        facilityCount
        associatedCredentialIds
      }
    }
  }
`);

export const GET_TENANTS = gql(`
  query TenantsForSteersCredentials {
    tenants {
      items {
        id
        name
      }
    }
  }
`);

export const GET_ALL_CREDENTIALS = gql(`
  query AllCredentialsForSteersAccess($search: String) {
    credentials(search: $search, pageSize: 50) {
      items {
        id
        username
        name
      }
    }
  }
`);

export const CREATE_ALTERNATE_ID_INFO = gql(`
  mutation CreateAlternateIdInfo($input: AlternateIdInfoInput!) {
    createAlternateIdInfo(input: $input) {
      id
      alternateIdType
      alternateIdValue
      tenantId
      description
    }
  }
`);

export const UPDATE_ALTERNATE_ID_INFO = gql(`
  mutation UpdateAlternateIdInfo($id: ID!, $input: AlternateIdInfoInput!) {
    updateAlternateIdInfo(id: $id, input: $input) {
      id
      alternateIdType
      alternateIdValue
      tenantId
      description
    }
  }
`);

export const DELETE_ALTERNATE_ID_INFO = gql(`
  mutation DeleteAlternateIdInfo($id: ID!) {
    deleteAlternateIdInfo(id: $id) {
      id
    }
  }
`);

export const ADD_STEERS_CREDENTIAL_ACCESS = gql(`
  mutation AddSteersCredentialAccess($credentialId: ID!, $alternateIdValue: String!) {
    addSteersCredentialAccess(credentialId: $credentialId, alternateIdValue: $alternateIdValue) {
      id
      credentialId
      alternateIdValue
      alternateIdType
    }
  }
`);

export const REMOVE_STEERS_CREDENTIAL_ACCESS = gql(`
  mutation RemoveSteersCredentialAccess($credentialId: ID!, $alternateIdValue: String!) {
    removeSteersCredentialAccess(credentialId: $credentialId, alternateIdValue: $alternateIdValue) {
      id
    }
  }
`);
